/**
 * Player-related Icons
 */
/* tslint:disable:max-line-length */
import * as React from 'react';
import * as BEM from 'react-bem-helper';

function IconWrapper({ children, className, id }) {
  const classes = new BEM('icon');
  return <div {...classes('', ['player', id], className)}>{children}</div>;
}

export function IconPlayerPlay({ className = '' }) {
  return (
    <IconWrapper id="play" className={className}>
      <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path d="M11.54 5.49L29.692 17.16c.465.298.6.917.3 1.382-.077.12-.179.223-.3.3L11.541 30.51c-.465.298-1.084.164-1.382-.3-.104-.162-.159-.35-.159-.542V6.332c0-.553.448-1 1-1 .192 0 .38.055.54.158z" fill="currentColor"/>
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconPlayerPause({ className = '' }) {
  return (
    <IconWrapper id="pause" className={className}>
      <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
          <path d="M10 6h4c.552 0 1 .448 1 1v22c0 .552-.448 1-1 1h-4c-.552 0-1-.448-1-1V7c0-.552.448-1 1-1zM22 6h4c.552 0 1 .448 1 1v22c0 .552-.448 1-1 1h-4c-.552 0-1-.448-1-1V7c0-.552.448-1 1-1z" fill="currentColor"/>
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconPlayerPrevious({ className = '' }) {
  return (
    <IconWrapper id="previous" className={className}>
      <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <g transform="matrix(-1 0 0 1 30 6)" fill="none" fillRule="evenodd">
          <path d="M6.625 5.3l7.399 5.92c.431.344.501.973.156 1.405-.046.057-.098.11-.156.156l-7.4 5.92c-.43.344-1.06.274-1.405-.157-.142-.177-.219-.398-.219-.625V6.081c0-.553.448-1 1-1 .227 0 .447.077.625.219z" fill="currentColor"/>
          <rect fill="currentColor" x="16" y="5" width="2" height="14" rx="1"/>
        </g>
      </svg>
    </IconWrapper>
  );
}
export function IconPlayerNext({ className = '' }) {
  return (
    <IconWrapper id="next" className={className}>
      <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(6 6)" fill="none" fillRule="evenodd">
          <path d="M6.625 5.3l7.399 5.92c.431.344.501.973.156 1.405-.046.057-.098.11-.156.156l-7.4 5.92c-.43.344-1.06.274-1.405-.157-.142-.177-.219-.398-.219-.625V6.081c0-.553.448-1 1-1 .227 0 .447.077.625.219z" fill="currentColor"/>
          <rect fill="currentColor" x="16" y="5" width="2" height="14" rx="1"/>
        </g>
      </svg>
    </IconWrapper>
  );
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/images/Icon/player-icons.tsx